module.exports = __webpack_public_path__ + "static/media/93.4e391a63.png";